const defaults = {
    logoUrl: null,
    maintext: '#424242',
    sidetext: '#FFFFFF',
    mainbg: '#FFFFFF',
    sidebg: '#ABABAB'
}

const state = {
    logoUrl: defaults.logoUrl,
    maintext: defaults.maintext,
    sidetext: defaults.sidetext,
    mainbg: defaults.mainbg,
    sidebg: defaults.sidebg
}

const getters = {
    logoUrl: state => state.logoUrl,
    maintext: state => state.maintext,
    mainbg: state => state.mainbg,
    sidetext: state => state.sidetext,
    sidebg: state => state.sidebg,
}

const actions = {
    changeTheme({commit, state}, obj) {
        let theme = obj.theme
        let maintext = defaults.maintext
        let sidetext = defaults.sidetext
        let mainbg = defaults.mainbg
        let sidebg = defaults.sidebg
        let logoUrl = null
        if (theme.logoUrl) {
            logoUrl = theme.logoUrl
        }

        if (theme.topbarColor) {
            mainbg = theme.topbarColor
            let c = theme.topbarColor.substring(1)
            let rgb = parseInt(c, 16)
            let r = (rgb >> 16) & 0xff
            let g = (rgb >> 8) & 0xff
            let b = (rgb >> 0) & 0xff

            let luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

            if (luma < 80) {
                maintext = '#FFFFFF'
            }
        }
        if (theme.sidebarColor) {
            sidebg = theme.sidebarColor;
            let c = theme.sidebarColor.substring(1)
            let rgb = parseInt(c, 16)
            let r = (rgb >> 16) & 0xff
            let g = (rgb >> 8) & 0xff
            let b = (rgb >> 0) & 0xff

            let luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

            if (luma < 80) {
                sidetext = '#FFFFFF'
            }
        }
        commit('updateLogoUrl', { url: logoUrl } )
        commit('updateMainText', { hex: maintext })
        commit('updateMainBackground', { hex: mainbg })
        commit('updateSidebarText', { hex: sidetext })
        commit('updateSidebarBackground', { hex: sidebg })
    }
}

const mutations = {
    updateLogoUrl ( state, { url }) {
        state.logoUrl = url
    },
    updateMainText ( state, { hex }) {
        state.maintext = hex
    },
    updateMainBackground ( state, { hex }) {
        state.mainbg = hex
    },
    updateSidebarBackground ( state, { hex }) {
        state.sidebg = hex
    },
    updateSidebarText ( state, { hex }) {
        state.sidetext = hex
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/app/store/modules/theme.js